import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from '../../../services/event-managers/toolbar-event-manager.helper';
import { DashboardHelper } from '../../../services/dashboard.service';
import { PermissionService } from '../../../services/permission.service';
import { BlueprintStore } from '../../../services/stores/blueprint.store';
import * as AppConstants from '../../../modules/catch-core/data/constants/app.constants';
import * as PermissionConstants from '../../../modules/catch-core/data/constants/permission.constants';

@Component({
  selector: 'app-agile-board-add-column',
  templateUrl: './agile-board-add-column.component.html',
  styleUrl: './agile-board-add-column.component.scss',
  standalone: false,
})
export class AgileBoardAddColumnComponent extends BaseComponent implements OnInit {
  public visible: boolean = false;
  private onTrackView: boolean = false;

  constructor(
    private dashboardHelper: DashboardHelper,
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private permissionService: PermissionService,
    private blueprintStore: BlueprintStore,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.currentApplication = this.dashboardHelper.$currentApplication.subscribe((res: any) => {
      const currentAppName = res?.displayName ? res.displayName.toLowerCase() : '';
      this.onTrackView = currentAppName === AppConstants.TRACK;
      this.recomputeVisibility();
    });
    // The gate depends on the selected blueprint (global flag), so re-evaluate when it changes.
    this.subscribers.selectedBluePrint = this.blueprintStore.$selectedBluePrint.subscribe(() => {
      this.recomputeVisibility();
    });
  }

  // Mirrors AgileBoardComponent.canEditBoardColumns: only show the toolbar Add Column button on the
  // Board view to a user who may actually add a column â€” CatchSystemAdmin for any blueprint, otherwise
  // a Non-Global blueprint with BOTH the blueprint edit (create) and delete privileges.
  private recomputeVisibility(): void {
    this.visible = this.onTrackView && this.canEditBoardColumns();
    this.cdr.detectChanges();
  }

  private canEditBoardColumns(): boolean {
    const bp = this.blueprintStore.selectedBluePrint;
    if (!bp) return false;
    if (this.permissionService.isSysAdmin) return true;
    if (bp.isGlobalBlueprint) return false;
    return (
      this.permissionService.hasPermission(PermissionConstants.TEMPLATE_CREATE) &&
      this.permissionService.hasPermission(PermissionConstants.TEMPLATE_DELETE)
    );
  }

  public onAddColumnClick(): void {
    this.toolbarEventManagerHelper.AgileBoardAddColumnTrigger = true;
  }
}
